import join from '../images/join.jpg'
import '../components/css components/logistics.css';
import prcover from "../images/cover-all.jpg";
import circle from "../images/pr-modified.png";

function Pr(){
    return(
        <div className='logistics' id='pr'>
                        <div className='stick-them'>
                            <img src={prcover} alt='logistics' className='cover-all'/>
                            <img src={circle} alt='logistics' className='circle-c' />
                        </div>     
                    <h2>PR&FR Circle</h2>
                    <p className='quote'>"The art of telling a story that the public wants to hear, and building relationships that people want to be a part of."</p>
                    <p className='paragraph'>The PR circle has a special role in representing the team, and here are their important tasks:
                        <ul>
                            <li>They communicate with different activities, organizations, and important people.</li>
                            <li>They coordinate with experts to help the team grow and succeed..</li>
                            <li>They find suitable venues for team events, like courses and workshops.</li>
                            <li>They help improve the team's reputation by working with our marketing team and making sure our name is known both inside and outside.</li>
                            <li>They talk to sponsors and donors to get support in the form of money or goods.</li>
                            <li>They work on increasing the team's financial resources and forming partnerships.</li>
                            <li>They also work on forming partnerships in the community and making sure we fulfill our social responsibilities.</li>
                        </ul>
The Fundraising Circle takes care of the team's finances, and these are their main responsibilities:
                        <ul>
                            <li>Communicating with sponsors and donors to obtain in-kind and cash support.</li>
                            <li>Developing the financial resources of the team and mutual partnerships. </li>
                        </ul>
                    </p>
        </div>
    );
}

export default Pr;